import { styled } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

export const StyledDataGrid = styled(DataGrid)({
  '& .highlighted-row': {
    backgroundColor: '#f3f3f3 !important',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: '#f3f3f3 !important',
    },
    fontStyle: 'italic',
  },
  '& .normal-row': {
    cursor: 'pointer',
  },
});
